module.exports = "<svg id=026501ec-d3d5-4352-a854-07bff0af76e8 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>ShuttingDown</title><path d=M15.09,4.52a.5.5,0,0,0-.65.29.49.49,0,0,0,.28.65,7.52,7.52,0,1,1-5.44,0,.49.49,0,0,0,.28-.65.5.5,0,0,0-.65-.29,8.53,8.53,0,1,0,6.18,0Z /><path d=M12.5,12.32V3.5a.5.5,0,0,0-1,0v8.82a.5.5,0,0,0,1,0Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/shutting-down.svg
// module id = 169
// module chunks = 0